import React, { lazy, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../_metronic/layout";
import { DashboardPage } from "./pages/DashboardPage";
// import { NotificationListing } from "./modules/Notifications/NotificationListing";
// import { NotificationPayment } from "./modules/Notifications/NotificationPayment";
// import { BankInformation } from "./modules/Notifications/BankInformation";
// import { HistoryListing } from "./modules/History/HistoryListing";
import { AccessLogPage } from "./modules/AccessLog/AccessLogPage";
import { CityPage } from "./modules/City/CityPage";
import Commission from "./modules/Commission/Commission";
import { CountryPage } from "./modules/Country/CountryPage";
import { HistoryPage } from "./modules/History/HistoryPage";
import { ReportAbusePage } from "./modules/ReportAbuse/ReportAbusePage";
import { ClearingAccountReportPage } from "./modules/Reports/Clearing Account Report/ClearingAccountReportPage";
import { TransactionsReportPage } from "./modules/Reports/Transactions Report/TransactionsReportPage";
import { StatePage } from "./modules/State/StatePage";
import { UserPage } from "./modules/User/UserPage";

const GoogleMaterialPage = lazy(() =>
  import("./modules/GoogleMaterialExamples/GoogleMaterialPage")
);
const ReactBootstrapPage = lazy(() =>
  import("./modules/ReactBootstrapExamples/ReactBootstrapPage")
);
const ECommercePage = lazy(() =>
  import("./modules/ECommerce/pages/eCommercePage")
);
const UserProfilepage = lazy(() =>
  import("./modules/UserProfile/UserProfilePage")
);

export default function BasePage() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <Route path="/history-listing" component={HistoryPage} />
        <Route path="/commission" component={Commission} />
        <Route path="/user-listing" component={UserPage} />
        <Route path="/country-listing" component={CountryPage} />
        {/* <Route path="/bank-listing" component={BankPage} /> */}
        <Route path="/city-listing" component={CityPage} />
        <Route path="/state-listing" component={StatePage} />
        <Route
          path="/reports/transactions-report"
          component={TransactionsReportPage}
        />
        <Route
          path="/reports/clearing-account-report"
          component={ClearingAccountReportPage}
        />
        <Route path="/report-abuse" component={ReportAbusePage} />
        <Route path="/access-log" component={AccessLogPage} />
        {/* <Route path="/notifications" component={NotificationListing} /> */}
        {/* <Route path="/notification-payment" component={NotificationPayment} /> */}
        {/* <Route path="/bank-information" component={BankInformation} /> */}
        {/* <Route path="/history-listing" component={HistoryListing} /> */}
        {/* <Route path="/make-payment" component={MakePayment} /> */}
        {/* <Route path="/request-payment" component={RequestPayment} /> */}
        {/* <Route path="/transfer-balance" component={TransferBalance} /> */}
        {/* <Route path="/contact-and-messaging" component={ContactandMessaging} /> */}
        {/* <Route path="/simple-chat" component={SimpleChat} /> */}
        {/* <ContentRoute path="/builder" component={BuilderPage} /> */}
        {/* <Route path="/google-material" component={GoogleMaterialPage} /> */}
        {/* <Route path="/react-bootstrap" component={ReactBootstrapPage} />
        <Route path="/e-commerce" component={ECommercePage} />
        <Route path="/user-profile" component={UserProfilepage} /> */}

        {/* <Route path="/bank-transactions" component={WithdrawPage} /> */}
        {/* <Route path="/bankAccount-listing" component={BankAccountPage} /> */}

        {/* <Route path="/subAdmin-listing" component={SubAdminPage} /> */}

        {/* <Route path="/refunds" component={Refunds} /> */}
        {/* <Route path="/notifications" component={Notifications} /> */}
      </Switch>
    </Suspense>
  );
}
